import PropTypes from 'prop-types';
import React from 'react';

export default function FootballMatchPlayerGoals(props) {
  return (
    <div className="footballMatchPlayerGoals">
      {props.playerGoals.team_player}
      {props.playerGoals.goal.map((eachGoal, index, array) =>
        <span key = {eachGoal.event_id}>
          &nbsp; {eachGoal.time}{eachGoal.type && <span> {eachGoal.type}</span>}
          {index != (array.length-1) ? <span>&#44;</span> :<span></span>}
        </span>
      )
      }
    </div>
  );
}

FootballMatchPlayerGoals.propTypes = {
  playerGoals: PropTypes.shape({
    team_player: PropTypes.string.isRequired,
    goal: PropTypes.array.isRequired
  }).isRequired
}



// WEBPACK FOOTER //
// ./modules/Football/components/FootballMatchPlayerGoals.js